export enum PaymentResultCode {
  AUTHORISED = 'Authorised',
  CANCELLED = 'Cancelled',
  CHALLENGESHOPPER = 'ChallengeShopper',
  ERROR = 'Error',
  IDENTIFYSHOPPER = 'IdentifyShopper',
  REDIRECTSHOPPER = 'RedirectShopper',
  REFUSED = 'Refused'
}

export type CheckoutPages = 'payment' | 'verify'
// TODO: check those types
export interface PaymentMethodEntry {
  cardBrand?: string
  cardExpiryMonth?: string
  cardExpiryYear?: string
  cardHolder?: string
  cardNumber?: string
  iban?: string
  id: string
  isDefault: boolean
  name: string
  owner?: string
}

export type PaymentType = { type: string }

export interface BlockedPaymentMethod {
  reason: string
  type: string
}
export interface Payment {
  paymentData?: PaymentData
  paymentKind: string
  paymentProviderTransactionId?: string
  paymentStatus?: PaymentResultCode
}
export interface PaymentData {
  IBAN?: string
  holderName?: string
  paymentDataId?: string
}

export interface AdyenBrowserInfo {
  acceptHeader: string
  colorDepth: number
  javaEnabled: boolean
  language: string
  screenHeight: number
  screenWidth: number
  timeZoneOffset: number
  userAgent: string
}

export interface AdyenPayment {
  encryptedCardNumber?: string
  encryptedExpiryMonth?: string
  encryptedExpiryYear?: string
  encryptedSecurityCode?: string
  holderName?: string
  storedPaymentMethodId?: string
  type: string
}

export interface AdyenPaymentRequest {
  browserInfo: AdyenBrowserInfo
  channel: string
  clientStateDataIndicator?: boolean
  origin?: string
  paymentMethod: AdyenPayment
  recurringProcessingModel?:
    | 'CardOnFile'
    | 'Subscription'
    | 'UnscheduledCardOnFile'
  reference: string
  returnUrl: string
  riskData?: AdyenRiskData
  shopperInteraction?: 'ContAuth' | 'Moto' | 'POS'
  shopperIP?: string
  shopperLocale: string
  shopperReference: string
  storePaymentMethod: boolean
}

export interface AdyenPaymentDetails {
  /**
   * response credit card
   */
  MD?: string
  /**
   * response credit card
   */
  PaRes?: string
  /**
   * response klarna payments (klarna, klarna_paynow, directEbanking)
   */
  redirectResult?: string
  /**
   * response paypal
   */
  payload?: string
}

export interface AdyenPaymentDetailsRequest {
  /**
   * orderDraftId
   */
  reference: string
  storePaymentMethod: boolean
  details?: AdyenPaymentDetails
}

export interface AdyenRiskData {
  clientData: string
}

export interface OriginKeysRequest {
  originDomains: string[]
}

export interface OriginKeysResponse {
  originKeys: OriginKeys
}

export interface OriginKeys {
  originDomain: string
}
